import { render, staticRenderFns } from "./banner-label.vue?vue&type=template&id=73064f18"
import script from "./banner-label.vue?vue&type=script&lang=js"
export * from "./banner-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports